import React, {useState} from 'react';
import {Button, Headline, Input} from '@lightricks/react-design-system';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import Modal from '@/components/modal/Modal';
import useCreateBrand from '@/hooks/mutations/use-create-brand';
import styles from './CreateBrandModal.module.scss';

interface CreateBrandModalProps {
  agencyId: string;
  isOpen: boolean;
  onClose: () => void;
}

function CreateBrandModal({agencyId, isOpen, onClose}: CreateBrandModalProps) {
  const [brandName, setBrandName] = useState('');
  const createBrand = useCreateBrand(agencyId);

  const handleCreate = () => {
    createBrand.mutate(
      {name: brandName},
      {
        onSuccess: () => {
          raiseFlashMessage({
            status: 'success',
            message: translate('Brand created successfully.'),
          });
          onClose();
        },
        onError: () => {
          raiseFlashMessage({
            status: 'error',
            message: translate('There was an error creating the brand.'),
          });
          onClose();
        },
      }
    );
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      showCloseButton
      size="small"
      contentClassName={styles.modal}
    >
      <div className={styles.container}>
        <Headline size="lg" data-test-org-settings-new-brand-modal-header>
          {translate('Create Brand')}
        </Headline>

        <label className={styles.label}>{translate('Brand Name')}</label>
        <Input
          value={brandName}
          onInputChange={(val: string) => setBrandName(val)}
          testID="new-brand-modal-brand-name"
          data-test-new-brand-modal-brand-name
        />

        <Button
          appearance="brand"
          mode="filled"
          size="medium"
          onClick={handleCreate}
          disabled={!brandName}
          data-test-organization-settings-new-brand-save
        >
          {translate('Add Brand')}
        </Button>
      </div>
    </Modal>
  );
}

export default CreateBrandModal;
